export default __webpack_public_path__ + "static/media/shutterstock_789106786 [Converted]-03.c6cd3d6c.png";